import { render, staticRenderFns } from "./DesignerOrders.vue?vue&type=template&id=731c9fde&scoped=true&"
import script from "./DesignerOrders.vue?vue&type=script&lang=js&"
export * from "./DesignerOrders.vue?vue&type=script&lang=js&"
import style0 from "./DesignerOrders.vue?vue&type=style&index=0&id=731c9fde&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "731c9fde",
  null
  
)

export default component.exports